export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["فحص العنوان"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أدخل العنوان"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["اختر البلوك تشين"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تنفيذ الفحص"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["مخاطر منخفضة"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["مخاطر متوسطة"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["مخاطر عالية"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ليس في القائمة السوداء"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["فحص عنوان آخر"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تنزيل PDF"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رجوع"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["اختر المزود"])}
}